import { render, staticRenderFns } from "./companyDialog.vue?vue&type=template&id=5884e972&scoped=true&"
import script from "./companyDialog.vue?vue&type=script&lang=ts&"
export * from "./companyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./companyDialog.vue?vue&type=style&index=0&id=5884e972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884e972",
  null
  
)

export default component.exports